import { render, staticRenderFns } from "./LossReport.vue?vue&type=template&id=797bff31&scoped=true"
import script from "./LossReport.vue?vue&type=script&lang=js"
export * from "./LossReport.vue?vue&type=script&lang=js"
import style0 from "./LossReport.vue?vue&type=style&index=0&id=797bff31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797bff31",
  null
  
)

export default component.exports